<template>
    <div>
        <h2>Persönliche Daten</h2>
        <ion-grid class="ion-padding-top">
            <ion-row>
                <ion-col size="10" offset="2">
                    <base-select
                        v-model="geschlecht"
                        :label="'Anrede'"
                        id="geschlecht"
                    >
                        <ion-select-option value="Frau">Frau</ion-select-option>
                        <ion-select-option value="Herr">Herr</ion-select-option>
                    </base-select>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="10" size-md="5" offset="2">
                    <base-input
                        id="vorname"
                        type="text"
                        v-model="vorname"
                        :label="'Vorname'"
                    ></base-input>
                </ion-col>
                <ion-col size="10" size-md="5" offset="2" offset-md="0">
                    <base-input
                        id="zuname"
                        type="text"
                        v-model="zuname"
                        :label="'Nachname'"
                    ></base-input>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="10" offset="2">
                    <base-datetime
                        :label="'Geburtsdatum'"
                        v-model="geburtsdatum"
                        id="geburtsdatum"
                    ></base-datetime>
                </ion-col>
            </ion-row>
            <ion-row>
                <ion-col size="10" size-md="5" offset="2">
                    <base-input
                        id="email"
                        type="email"
                        v-model="email"
                        :label="'E-Mail'"
                    ></base-input>
                </ion-col>
                <ion-col size="10" size-md="5" offset="2" offset-md="0">
                    <base-input
                        id="telefon"
                        type="tel"
                        v-model="telefon"
                        :label="'Telefonnummer'"
                    ></base-input>
                </ion-col>
            </ion-row>
            <ion-row v-if="mode === 'krankenhaus' || mode === 'unfall'">
                <ion-col size="10" offset="2">
                    <base-input
                        id="iban"
                        v-model="iban"
                        type="text"
                        label="IBAN"
                        :mask="{ mask: 'aa00 0000 0000 0000 0000 00' }"
                        @onAccept="unmaskedIban = $event"
                        clearInput
                    ></base-input>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="ion-text-right">
            <ion-button
                class="-round -add-padding ion-margin-top"
                :disabled="
                    [
                        geschlecht,
                        vorname,
                        zuname,
                        geburtsdatum,
                        email,
                        telefon,
                    ].includes('') ||
                    ((mode === 'krankenhaus' || mode === 'unfall') &&
                        iban === '')
                "
                @click="
                    $emit('change', [
                        {
                            id: 'geschlecht',
                            value: geschlecht,
                        },
                        {
                            id: 'vorname',
                            value: vorname,
                        },
                        {
                            id: 'zuname',
                            value: zuname,
                        },
                        {
                            id: 'geburtsdatum',
                            value: geburtsdatum,
                        },
                        {
                            id: 'email',
                            value: email,
                        },
                        {
                            id: 'telefon',
                            value: telefon,
                        },
                        {
                            id: 'iban',
                            value: unmaskedIban,
                        },
                    ])
                "
                >Weiter</ion-button
            >
        </div>
    </div>
</template>

<script>
import BaseSelect from "@/components/BaseSelect";
import BaseInput from "@/components/BaseInput";
import BaseDatetime from "@/components/BaseDatetime";

export default {
    components: { BaseSelect, BaseInput, BaseDatetime },
    props: {
        mode: {
            required: false,
            type: String,
            default: "",
        },
        contractId: {
            required: false,
            type: String,
            default: "",
        },
    },
    data() {
        return {
            geschlecht: "",
            vorname: "",
            zuname: "",
            geburtsdatum: "",
            email: "",
            telefon: "",
            iban: "",
            unmaskedIban: "",
        };
    },
    mounted() {
        if (this.$store.state.isLoggedIn) {
            if (Object.keys(this.$store.state.user.details).length > 0) {
                let userDetails = this.$store.state.user.details;
                this.geschlecht = userDetails.geschlecht;
                this.vorname = userDetails.vorname;
                this.zuname = userDetails.nachname;
                if (userDetails.geburtstag) {
                    this.geburtsdatum = userDetails.geburtstag
                        .split(".")
                        .reverse()
                        .join("-");
                }
                this.email = userDetails.email;
                this.telefon = userDetails.telefon;
            }

            if (
                this.mode === "krankenhaus" &&
                this.$store.state.contracts[this.contractId]
            ) {
                this.$store.cache
                    .dispatch(
                        "contractsDetails/getContractDetails",
                        this.contractId
                    )
                    .then(() => {
                        if (
                            this.contractId in
                            this.$store.state.contractsDetails.all
                        ) {
                            const contractDetails = this.$store.state
                                .contractsDetails.all[this.contractId];
                            if (
                                contractDetails.BankAccountData &&
                                contractDetails.BankAccountData.Iban
                            ) {
                                this.iban =
                                    contractDetails.BankAccountData.Iban;
                            }
                        }
                    });
            }
        }
    },
};
</script>

<style lang="scss" scoped></style>
